import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(props: any) => props.theme.colors.interfacePure0};
`

export const Card = styled.div`
    width: 100%;
    max-width: 440px;
    border-radius: 16px;
    padding: 40px;
    background: ${(props: any) => props.theme.colors.white};
    border: 1px solid ${(props: any) => props.theme.colors.interfaceBorder100};
`

export const IconsRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-bottom: 24px;
`

export const Title = styled.h2`
    font-size: 22px;
    font-weight: 700;
    text-align: center;
    color: ${(props: any) => props.theme.colors.interfaceGray400};
    margin-bottom: 12px;
`

export const Subtitle = styled.p`
    font-size: 15px;
    font-weight: 400;
    text-align: center;
    color: ${(props: any) => props.theme.colors.interfaceGray100};
    line-height: 22px;
    margin-bottom: 24px;

    span.highlight {
        color: ${(props: any) => props.theme.colors.primaryRed400};
        font-weight: 600;
    }
`

export const PasswordWrapper = styled.div`
    position: relative;

    .icon {
        position: absolute;
        top: 40%;
        right: 5%;
        cursor: pointer;
    }
`

export const DenyButton = styled.button`
    display: block;
    width: 100%;
    background: transparent;
    border: none;
    text-align: center;
    color: ${(props: any) => props.theme.colors.interfaceGray100};
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`

export const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`

export const ErrorMessage = styled.p`
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    color: ${(props: any) => props.theme.colors.interfaceDanger};
    margin-bottom: 16px;
`
